import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { get_candidate_assigned_assessment_kits_data_action } from "../../../redux/_actions/";
import { appRoutes } from "../../../_routes/app-routes";

function useCandidateAssessments(props) {
  const [candidateAssignedAssessments, setCandidateAssignedAssessments] =
    useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [candidateData, setCandidateData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const outerClickRef = useRef();

  //get data from redux
  const { candidateAssignedAssessmentsData } = useSelector(
    (state) => state.get_candidate_assigned_assessment_kits_data_reducer
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    callApi();
  }, []);

  useEffect(() => {
    if (candidateAssignedAssessmentsData) {
      setCandidateAssignedAssessments(candidateAssignedAssessmentsData);
      setCandidateData(candidateAssignedAssessmentsData);
    }
  }, [candidateAssignedAssessmentsData]);

  const callApi = async () => {
    setIsLoading(true);
    await dispatch(get_candidate_assigned_assessment_kits_data_action());
    setIsLoading(false);
  };

  const onViewDetailsClick = (id) => {
    navigate(
      appRoutes.assessementKit.assignedAssessmentDetail.replace(
        ":assessmentId",
        id
      )
    );
  };
  const getStatusCount = (assessmentData, status) => {
    if (Array.isArray(assessmentData?.status_count)) {
      let statusCount = assessmentData.status_count.filter(
        (item) => item.status === status
      );

      return (statusCount && statusCount[0]?.count) || 0;
    }
    return 0;
  };

  const onTakeAssessmentClick = (id) => {
    navigate(
      appRoutes.assessementKit.previewAssessment.replace(
        ":assignedAssessmentId",
        id
      )
    );
  };

  const onFilterChange = async (filteredVal) => {
    // const filteredVal = e.target.value;
    if (filteredVal === "all") {
      setCandidateData(candidateAssignedAssessments);
    } else {
      const filteredData =
        Array.isArray(candidateAssignedAssessments) &&
        candidateAssignedAssessments.filter(
          (item) => item?.status === filteredVal
        );
      setCandidateData(filteredData);
    }
    setSelectedFilter(filteredVal);
    outerClickRef.current.click();
  };

  return {
    isLoading,
    candidateAssignedAssessments,
    selectedFilter,
    candidateData,
    outerClickRef,
    getStatusCount,
    onViewDetailsClick,
    onTakeAssessmentClick,
    onFilterChange,
  };
}
export default useCandidateAssessments;
